export const SCHEMA_CONTEXT = "https://schema.org";
export const SCHEMA_DEFAULT_LANGUAGE = "pt-BR";

export type SchemaProjectName = "home" | "rb" | (string & {});
